export const PERMISSION_GROUPS = {
  contact: [
    'platform:company.communication_interaction:access',
    'platform:company.contact:read:all',
    'platform:company.contact:export',
    'platform:company.contact:assign:all',
    'platform:company.contact:access',
    'platform:company.contact:create',
    'platform:company.contact:update:all',
  ],
  communicationInteraction: [
    'platform:company.communication_interaction.content:read:all',
    'platform:company.communication_interaction:read:all',
    'platform:company.communication_interaction:update:all',
    'platform:company.communication_interaction:delete:all',
    'platform:company.communication_interaction:read:own',
    'platform:company.communication_interaction:update:own',
    'platform:company.communication_interaction:delete:own',
  ],
  crm: [
    'crm:company.contact_note:update:all',
    'crm:company.contact_note:delete:all',
    'crm:company.contact_note:update:own',
    'crm:company.contact_note:delete:own',
    'platform:company.contact_attachment:update:all',
    'platform:company.contact_attachment:delete:all',
    'crm:access',
    'crm:company.task:access',
    'crm:company.task:create',
    'crm:company.task:read:all',
    'crm:company.task:read:own',
    'crm:company.task:update:all',
    'crm:company.task:delete:all',
    'crm:company.appointment:access',
    'crm:company.appointment:create',
    'crm:company.appointment:read:all',
    'crm:company.appointment:read:own',
    'crm:company.appointment:update:all',
    'crm:company.appointment:delete:all',
  ],
  user: [
    'platform:company.user:access',
    'platform:company.user:read:all',
    'platform:company.user:create',
    'platform:company.user:update:all',
    'platform:company.user:unassign_multiple_contacts',
  ],
  company: [
    'platform:company:access',
    'platform:company:update',
    'platform:company.dashboard:access',
    'api:key:access',
    'api:key:read:own',
    'api:key:update:own',
    'api:webhook:create',
    'api:webhook:delete:all',
    'platform:company.report:access',
    'platform:company.communication_interaction.template:share:all',
    'platform:company.lead_review.result:read:all',
    'platform:lead_review:access',
  ],
  campaign: [
    'platform:company.campaign:access',
    'platform:company.campaign:read:all',
    'platform:company.campaign:create',
    'platform:company.campaign:update:all',
    'platform:company.source:access',
    'platform:company.source:read:all',
    'platform:company.source:create',
    'platform:company.source:update:all',
  ],
  tracking: [
    'platform:company.tracking:access',
    'platform:company.callflow:access',
    'platform:company.resource:access',
    'platform:company.contact_tag:access',
  ],
  channel: [
    'platform:company.channel:access',
    'platform:company.channel.facebook:access',
    'platform:company.channel.instagram:access',
  ],
  broadcast: [
    'platform:company.broadcast:access',
    'platform:company.broadcast:read:all',
    'platform:company.broadcast:create',
    'platform:company.broadcast:update:all',
  ],
  aiAgents: [
    'ai:company.ai_agent_knowledge_base:access',
    'ai:company.ai_agent_knowledge_base:read:all',
    'ai:company.ai_agent_knowledge_base:read:own',
    'ai:company.ai_agent_knowledge_base:create',
    'ai:company.ai_agent_knowledge_base:update:all',
    'ai:company.ai_agent_knowledge_base:update:own',
    'ai:company.ai_agent_knowledge_base:delete:all',
    'ai:company.ai_agent_knowledge_base:delete:own',
    'ai:company.ai_agent:access',
    'ai:company.ai_agent:read:all',
    'ai:company.ai_agent:read:own',
    'ai:company.ai_agent:update:all',
    'ai:company.ai_agent:update:own',
  ],
  organization: [
    'platform:organization:access',
    'platform:organization:update',
    'platform:organization.user:access',
    'platform:organization.user:read:all',
    'platform:organization.user:create',
    'platform:organization.user:update:all',
    'platform:organization.user:update:all_except_admin',
    'platform:organization.billing:access',
    'platform:organization.company:access',
    'platform:organization.company:read:all',
    'platform:organization.company:create',
    'platform:organization.company:update:all',
    'platform:organization.resource:access',
    'platform:organization.resource:transfer',
  ],
  agency: [
    'platform:agency:access',
    'platform:agency:update',
    'platform:agency.user:access',
    'platform:agency.user:read:all',
    'platform:agency.user:create',
    'platform:agency.user:update:all',
    'platform:agency.organization:access',
    'platform:agency.organization:read:all',
    'platform:agency.organization:create',
    'platform:agency.organization:update:all',
    'platform:agency.report:access',
  ],
  system: [
    'platform:system:access',
    'platform:lead_review.reviewer:access',
    'platform:account_executive:access',
    'platform:backend:access',
  ],
} as const;

export type LggPermission =
  (typeof PERMISSION_GROUPS)[keyof typeof PERMISSION_GROUPS][number];

export const PERMISSIONS: LggPermission[] = Object.values(PERMISSION_GROUPS).flat();
